async function subscribeToPush(element) {

    const vapidPublicKey = element.dataset.key;
    const isIOSStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

    if (!isIOSStandalone) {
        alert("Bitte füge diese App zuerst zum Home-Bildschirm hinzu.");
        return;
    }

    if (!("serviceWorker" in navigator)) {
        alert("Service Worker werden nicht unterstützt.");
        return;
    }

    if (!("PushManager" in window)) {
        alert("Push-Benachrichtigungen werden nicht unterstützt.");
        return;
    }

    try {
        // Service Worker registrieren
        const registration = await navigator.serviceWorker.register("/service-worker.js");

        await navigator.serviceWorker.ready;

        // Berechtigung anfragen
        const permission = await Notification.requestPermission();

        if (permission !== "granted") {
            alert("Benachrichtigungen wurden nicht erlaubt.");
            return;
        }

        // Bereits vorhanden?
        let subscription = await registration.pushManager.getSubscription();

        if (!subscription) {
            subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
            });
        }

        // An Rails senden
        await fetch("/user/push_subscriptions", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
            },
            body: JSON.stringify(subscription)
        });

        alert("Push-Benachrichtigungen erfolgreich aktiviert.");

    } catch (e) {
        console.error(e);
        alert("Fehler: " + e.message);
    }
}

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, "+")
        .replace(/_/g, "/");

    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
}

export default subscribeToPush;